import type {NextPage} from 'next'
import Hotels from '../../app/components/Hotels'
import {NextSeo} from "next-seo";
import Helper from "../../app/modules/Helper";
import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {checkCookieSearchData, init} from "../../actions/baseActions";

export type LocationTexts = {
  metaTitle: string;
  metaDescription: string;
  h1: string;
  h2: string;
  newsletter: string;
}

const HotelsCityLocationPage: NextPage = (props: any) => {
    const location = props.location;
    function capitalize(str:string) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const locationName = location.split(' ').map(capitalize).join(' ');
    const metaTitle = Helper.trans('mainArea.hotels.city.location.metaTitle',{location: locationName});
    const metaDescription = Helper.trans('mainArea.hotels.city.location.metaDescription',{location: locationName});
    const h1 = Helper.trans('mainArea.hotels.city.location.h1',{location: locationName});
    const h2 = Helper.trans('mainArea.hotels.city.location.h2',{location: locationName});
    const newsletter = Helper.trans('mainArea.hotels.city.location.newsletter',{location: locationName});
    const texts: LocationTexts = {
        metaTitle,
        metaDescription,
        h1,
        h2,
        newsletter,
    }

    const dispatch = useDispatch();
    useEffect(function (){
        init('hotels')(dispatch)
        checkCookieSearchData()(dispatch)
    },[])
    return (
        <div>
            <NextSeo
                title={texts.metaTitle}
                description={texts.metaDescription}
                canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/hotels/city/${location}`}
                openGraph={{
                    url: `${process.env.NEXT_PUBLIC_SITE_URL}/hotels/city/${location}`,
                    title: texts.metaTitle,
                    description: texts.metaDescription,
                    site_name: process.env.NEXT_PUBLIC_SITE_NAME,
                }}
            />
            <Hotels
                dynamic
                useHeadline
                location={location}
                slug={`hotels/city/${location}`}
                query={
                    // @ts-ignore
                    { ...props.query, texts }
                }
            />
        </div>
    )
}

export async function getServerSideProps(ctx: any) {
  const location = ctx.query.location
  const query = ctx.query
  return {
    props: {location, query}, // will be passed to the page component as props
  }
}

export default HotelsCityLocationPage
